import { Checkbox, CheckboxProps } from '@chakra-ui/react'
export type { CheckboxProps }

export default Checkbox
